import { Component, computed, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { ILineItems } from '../../../../models/ILineItems';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { ItemDetailsService } from '../../../../services/items/item-details.service';
import { IItemDetails } from '../../../../models/IItemDetails';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMinus, faPlus, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToastMessageService } from '../../../../services/toast-message/toast-message.service';


@Component({
  selector: 'app-checkout-element',
  imports: [
    FormsModule,
    FontAwesomeModule,
    InputNumberModule,
  ],
  templateUrl: './checkout-element.component.html',
  styleUrl: './checkout-element.component.scss'
})
export class CheckoutElementComponent {
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService)
  private readonly itemDetailsService = inject(ItemDetailsService);
  private readonly toastMessageService = inject(ToastMessageService);

  public lineItem = input.required<ILineItems>();
  public currency = input.required<string>();
  public updateElementSignal = output<ILineItems>();
  public removeElementSignal = output<ILineItems>();

  private details = signal<IItemDetails | null>(null);
  private quantity = signal(1);

  protected icons = {
    faTrashAlt: faTrashAlt,
    faPlus: faPlus,
    faMinus: faMinus,
  }

  constructor() {
    effect(() => {
      const lineItem = this.lineItem();
      this.itemDetailsService.getItemDetails(lineItem.id).then(details => {
        this.details.set(details)
        if (details.quantityAvailable < 1) {
          this.toastMessageService.error("The item " + details.name + " is no longer available. It has been removed from your cart.");
          this.removeElementSignal.emit(lineItem);
        } else if (details.quantityAvailable < lineItem.quantity) {
          this.toastMessageService.warn("There are no longer enough available items for your request of  " + lineItem.quantity + " of " + details.name + ". The quantity has been automatically reduced to " + details.quantityAvailable + ".");
          lineItem.quantity = details.quantityAvailable;
          this.updateElement(lineItem);
        }
      });
      this.quantity.set(lineItem.quantity);
    });
  }

  protected imageUrl = computed(() => {
    const details = this.details();
    if (details != null) {
      return this.absoluteMediaUriService.getAbsoluteMediaUri(details.imageUrl);
    }
    return '';
  })

  protected itemName = computed(() => {
    const details = this.details();
    if (details != null) {
      return details.name;
    }
    return '';
  })

  protected itemPrice = computed(() => {
    const details = this.details();
    if (details != null) {
      return details.buyNowPrice;
    }
    return '';
  })

  protected quantityAvailable = computed(() => {
    const details = this.details();
    if (details != null) {
      return details.quantityAvailable;
    }
    return 1;
  })

  protected lineTotal = computed(() => {
    const details = this.details();
    if (details != null) {
      if (details.numericBuyNowPrice != null) {
        const lineTotal = (details.numericBuyNowPrice * this.quantity()).toFixed(2) + ' ' + this.currency();
        return lineTotal;
      }
      return details.buyNowPrice;
    }
    return 0;
  })

  protected updateElement(lineItem: ILineItems) {
    this.updateElementSignal.emit(lineItem);
    this.quantity.set(lineItem.quantity);
  }
}
